module.exports = __webpack_public_path__ + "static/img/RASM600_1.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/produkty/RASM600_1.png
// module id = N50G
// module chunks = 0